'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/2/25.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = require('react-collapse');

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import FlipCard from '../FlipCard/FlipCard';

var ListPageFilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ListPageFilterBar, _Component);

  function ListPageFilterBar() {
    (0, _classCallCheck3.default)(this, ListPageFilterBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ListPageFilterBar).call(this));

    _this.state = {
      isOpened: false,
      itemHeaderId: '1',
      whichSlide250: 2
    };
    return _this;
  }

  (0, _createClass3.default)(ListPageFilterBar, [{
    key: 'onItemMoreBtnClick',
    value: function onItemMoreBtnClick() {
      var isOpened = this.state.isOpened;

      this.setState({
        isOpened: !isOpened
      });
    }
  }, {
    key: 'onItemHeaderClick',
    value: function onItemHeaderClick(id) {
      this.setState({
        itemHeaderId: id
      });
    }
  }, {
    key: 'onDesigerMouseOver',
    value: function onDesigerMouseOver(id) {
      this.setState({
        whichSlide250: id
      });
    }
  }, {
    key: 'itemClick',
    value: function itemClick(id) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onItemClick(id);
        window.scrollTo(0, sTop);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./DesignerFilterBar.scss');
      var data = this.props.data;
      var _state = this.state;
      var itemHeaderId = _state.itemHeaderId;
      var isOpened = _state.isOpened;
      var whichSlide250 = _state.whichSlide250;

      var secondImgs = [];
      var designerFilterDiv = '';
      var thirdHeaderArray = [{ id: '1', name: 'ABCDEFG' }, { id: '2', name: 'HIJKLM' }, { id: '3', name: 'NOPQRS' }, { id: '4', name: 'TUVWXYZ' }];
      var thirdItemArray = [];
      if (data instanceof Array) {
        data.forEach(function (currentItem, index) {
          if (currentItem.recommond === '1' && secondImgs.length < 6) {
            var currentClassName = styles.loadItemLi;
            if (secondImgs.length % 6 === 5) {
              currentClassName += ' ' + styles.loadMarginRight;
            }
            secondImgs.push(_react2.default.createElement(
              'li',
              { key: index, className: currentClassName
                // onClick={()=>this.itemClick(currentItem.masterId)}
                , style: { zIndex: data.length - index, width: whichSlide250 === index ? '250px' : '182px' },
                onMouseOver: function onMouseOver() {
                  return _this2.onDesigerMouseOver(index);
                } },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/designer/' + currentItem.masterId, target: '_blank' },
                _react2.default.createElement('img', { src: currentItem.img, alt: '' }),
                _react2.default.createElement(
                  'p',
                  null,
                  currentItem.name
                ),
                _react2.default.createElement(
                  'div',
                  { style: { display: 'none' }, className: styles.nameContainer },
                  _react2.default.createElement('div', { className: styles.nameDiv, style: { height: 75 } }),
                  _react2.default.createElement(
                    'h3',
                    { className: styles.honorText },
                    currentItem.honor
                  ),
                  _react2.default.createElement(
                    'h3',
                    { className: styles.nameText },
                    currentItem.name
                  ),
                  _react2.default.createElement(
                    'h3',
                    { className: styles.fieldText },
                    currentItem.field
                  )
                )
              )
            ));
          }
          var currentThirdHeader = thirdHeaderArray.find(function (item) {
            return item.id === itemHeaderId;
          });
          if (currentThirdHeader && currentItem.groupId.length > 0 && currentThirdHeader.name.split('').indexOf(currentItem.groupId[0]) > -1) {
            thirdItemArray.push(_react2.default.createElement(
              'li',
              { key: index, className: styles.thirdItemText },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  to: '/designer/' + currentItem.masterId, target: '_blank' },
                currentItem.name
              )
            ));
          }
        });
        designerFilterDiv = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.ds_name_back },
            _react2.default.createElement(
              'ul',
              null,
              secondImgs
            )
          ),
          _react2.default.createElement(
            'i',
            { className: styles.addBtn },
            _react2.default.createElement('img', { onClick: this.onItemMoreBtnClick.bind(this),
              src: isOpened ? 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_app.png' : 'http://tupian.goeasy.cn:9999/yipinwang/third/shuaixuan_add.png',
              alt: '' })
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            _reactCollapse2.default,
            { isOpened: isOpened },
            _react2.default.createElement(
              'div',
              { className: styles.thirdItem },
              _react2.default.createElement(
                'div',
                { className: styles.thirdHeader },
                _react2.default.createElement(
                  'div',
                  { className: styles.shaixuan_tishi },
                  '按拼音首字母'
                ),
                thirdHeaderArray instanceof Array ? thirdHeaderArray.map(function (currentItem, index) {
                  var currentItemClass = styles.shaixuan_zimu;
                  if (currentItem.id === itemHeaderId) {
                    currentItemClass = styles.shaixuan_zimu + ' ' + styles.active;
                  }
                  return _react2.default.createElement(
                    'div',
                    { key: index, onClick: function onClick() {
                        return _this2.onItemHeaderClick(currentItem.id);
                      },
                      className: currentItemClass },
                    currentItem.name
                  );
                }) : ''
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'div',
                { style: { width: '100%', height: 37 } },
                _react2.default.createElement(
                  'ul',
                  null,
                  thirdItemArray
                )
              )
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        designerFilterDiv
      );
    }
  }]);
  return ListPageFilterBar;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array,
  onItemClick: _react.PropTypes.func
}, _temp);
exports.default = ListPageFilterBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DesignerFilterBar/DesignerFilterBar.js
 ** module id = 1325
 ** module chunks = 0
 **/